import React from "react";
import { decorators } from "@orange-marmalade/paginate-this";
import _ from "lodash";
import Aircraft from "MODULES/companies/components/Detail/Fleets/Aircraft";

export function Table({ results }) {
  return (
    <table className="table table-condensed">
      <tbody>
        <tr>
          <td width="100%">
            {_.orderBy(results, [r => r.model_number]).map(r => (
              <Aircraft aircraft={r} key={r.id} />
            ))}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

const Decorated = decorators.tabulate(Table);

export default () => <Decorated listId="company/aircrafts" />;



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/Fleets/Table.jsx